import BreadcrumbTitle from "components/BreadcrumbTitle"
import { LoadingIndicator } from "components/LoadingIndicator"
import PageMetaTags from "components/PageMetaTags"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap"
import { getFormValues, initialize } from "redux-form"
import {
  fetchOnboardingSettings,
  hideConfirmation,
  saveOnboardingSettings,
} from "store/actions"
import { mapAPIresponseToForm, mapFormToAPI } from "./utils"
import Wizard from "./wizard"

const PAGE_TITLE = "Onboarding flow"

const AppSetupOnboarding = ({
  wizardValues,
  showLoadingIndicator,
  fetchOnboardingSettings,
  onboardingSettings,
  saveOnboardingSettings,
  initializeForm,
}) => {
  useEffect(() => {
    fetchOnboardingSettings()
  }, [])

  useEffect(() => {
    if (onboardingSettings) {
      initializeForm(mapAPIresponseToForm(onboardingSettings))
    }
  }, [onboardingSettings])

  const handleSave = event => {
    event.preventDefault()
    saveOnboardingSettings(mapFormToAPI(wizardValues))
  }

  const [breadcrumbItems, setBreadcrumbItems] = useState([])

  return (
    <div className="page-content">
      <PageMetaTags title={PAGE_TITLE} />
      <Container fluid>
        <BreadcrumbTitle title={PAGE_TITLE} breadcrumbItems={breadcrumbItems} />
        <Row>
          {showLoadingIndicator && (
            <Modal isOpen={showLoadingIndicator} centered={true} size="sm">
              <CardBody className={"p-2 my-1 text-center"}>
                <Spinner className="ms-2" color="primary" />
              </CardBody>
            </Modal>
          )}
          <Col>
            <Card>
              <CardBody>
                <Wizard
                  handleSave={handleSave}
                  // initialValues={mapAPIresponseToForm(onboardingSettings)}
                  setBreadcrumbItems={setBreadcrumbItems}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

const mapStateToProps = state => ({
  wizardValues: getFormValues(FORM_NAMES.ONBOARDING_FLOW_WIZARD)(state),
  showLoadingIndicator: state.onboardingFlow.showLoadingIndicator,
  onboardingSettings: state.onboardingFlow.onboardingSettings,
  isConfirmationVisible: state.onboardingFlow.isConfirmationVisible,
})

const mapDispatchToProps = dispatch => ({
  fetchOnboardingSettings: () => dispatch(fetchOnboardingSettings()),
  saveOnboardingSettings: onboardingSettings =>
    dispatch(saveOnboardingSettings(onboardingSettings)),
  hideConfirmation: () => dispatch(hideConfirmation()),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.ONBOARDING_FLOW_WIZARD, values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AppSetupOnboarding)
